import { Facebook, Instagram } from "lucide-react";

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-[#1a1f1a]">
      {/* Hero Section */}
      <div 
        className="relative h-[400px] bg-cover bg-center"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1598962099619-528a224cb625?crop=entropy&cs=srgb&fm=jpg&q=85')"
        }}
      >
        <div className="absolute inset-0 bg-black/50" />
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white text-center">
            About Us
          </h1>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 py-16">
        {/* Tagline */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-amber-400 mb-4">
            Quality Produce, Every Time
          </h2>
        </div>

        {/* Story Content */}
        <div className="bg-[#2a2f2a] rounded-2xl p-8 md:p-12 mb-12">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-white mb-4">
              Our Commitment to Quality
            </h3>
            <div className="space-y-4 text-gray-300 leading-relaxed">
              <p>
                We are dedicated to providing the freshest, highest-quality produce to businesses and consumers alike.
              </p>
              <p>
                Our team works directly with growers to ensure that every fruit and vegetable meets our strict quality standards.
              </p>
              <p>
                Have a question about our products or want to place a custom order? Get in touch with us!
              </p>
            </div>
          </div>
        </div>

        {/* Values Section */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          <div className="bg-[#2a2f2a] rounded-xl p-6 text-center">
            <div className="w-16 h-16 bg-green-600/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h4 className="text-lg font-semibold text-white mb-2">Fresh Quality</h4>
            <p className="text-gray-400 text-sm">Premium produce sourced from trusted growers</p>
          </div>
          <div className="bg-[#2a2f2a] rounded-xl p-6 text-center">
            <div className="w-16 h-16 bg-amber-600/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h4 className="text-lg font-semibold text-white mb-2">Reliable Service</h4>
            <p className="text-gray-400 text-sm">Consistent delivery you can count on</p>
          </div>
          <div className="bg-[#2a2f2a] rounded-xl p-6 text-center">
            <div className="w-16 h-16 bg-red-600/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
              </svg>
            </div>
            <h4 className="text-lg font-semibold text-white mb-2">Customer Focus</h4>
            <p className="text-gray-400 text-sm">Your satisfaction is our priority</p>
          </div>
        </div>

        {/* Social Media Section */}
        <div className="bg-[#2a2f2a] rounded-2xl p-8 text-center">
          <h3 className="text-2xl font-bold text-white mb-4">Follow Us</h3>
          <p className="text-gray-400 mb-6">Stay connected with us on social media for updates and fresh produce inspiration!</p>
          <div className="flex justify-center gap-4">
            <a 
              href="https://www.facebook.com/p/Henrys-fresh-aussie-fruit-and-vegg-100057340634162/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition-colors"
              data-testid="facebook-link"
            >
              <Facebook className="w-5 h-5" />
              <span>Facebook</span>
            </a>
            <a 
              href="https://www.instagram.com/henrysaussiefruitandveggies/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white px-6 py-3 rounded-lg transition-colors"
              data-testid="instagram-link"
            >
              <Instagram className="w-5 h-5" />
              <span>Instagram</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
